import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Switch>
        <Route
          path={`${AUTH_PREFIX_PATH}/login`}
          component={lazy(() => import(`./authentication/send-otp`))}
        />
        <Route
          path={`${AUTH_PREFIX_PATH}/verify-otp`}
          component={lazy(() => import(`./authentication/verify-otp`))}
        />
        {/* TODO: Call from App.js */}
        <Route
          path={`${AUTH_PREFIX_PATH}/not-authorized`}
          component={lazy(() => import(`./errors/not-authorized`))}
        />
        <Redirect
          from={`${AUTH_PREFIX_PATH}`}
          to={`${AUTH_PREFIX_PATH}/login`}
        />
      </Switch>
    </Suspense>
  );
};

export default AppViews;
